import { Charts } from './Charts';
import APHChartsDataProvider from './contexts/APHChartsDataContext';

const APHWrapper = () => {
    return (
        <APHChartsDataProvider>
            <Charts />
        </APHChartsDataProvider>
    );
};

export default APHWrapper;
